
/**
 * 计算两个坐标点的距离。单位：米
 * @param {object} coordinate1 坐标点1
 * @param {object} coordinate2 坐标点2
 */
export function getDistance(coordinate1, coordinate2) {
  var dis = 0;
  var radLat1 = toRadians(coordinate1.lat);
  var radLat2 = toRadians(coordinate2.lat);
  var deltaLat = radLat1 - radLat2;
  var deltaLng = toRadians(coordinate1.lng) - toRadians(coordinate2.lng);

  dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
  return dis * 6378137;
}

function toRadians(d) {
  return d * Math.PI / 180;
}



// 计算里程
export function caculateDistance(route = {}) {
  let result = 0;

  for (let key in route) {
    let item = route[key];
    if (!item) continue;
    let {routes} = item;

    if (routes) {
      result += routes.distance;
    }
  }

  return result;
}

/**
 * 公里数格式化
 * 将单位转化为公里（默认为米）
 * 单位：公里
 * 若公里数≥10公里，则保留整数
 * 若公里数＜10公里，保留1位小数
 */
export function formatDistance(distance) {
  distance = distance / 1000;
  if(distance > 10){
    distance = distance.toFixed(0);
  }else{
    distance = distance.toFixed(1);
    distance = parseFloat(distance);  
  }
 
  if (distance === 0) {
    distance = 0.1;
  }

  return distance;
}

// 计算油耗
export function caculateOils(route = {}) {
  let result = 0;

  for (let key in route) {
    let item = route[key];
    if (!item) continue;
    let {routes} = item;

    if (routes) {
      result += routes.oils;
    }
  }

  return result;
}

/**
 * 油耗格式化
 * 单位：升
 * 若油耗≥10升，则保留整数
 * 若公里数＜10升，保留1位小数
 * @param {*} oils 
 */
export function formatOils(oils) {
  if(oils > 10){
    oils = oils.toFixed(0);
  }else{
    oils = oils.toFixed(1);
    oils = parseFloat(oils);
  }

  if (oils === 0) {
    oils = 0.1;
  }

  return oils;
}

// 计算耗时
export function caculateDuration(route = {}) {
  let result = 0;

  for (let key in route) {
    let item = route[key];
    if (!item) continue;
    let {routes} = item;

    if (routes) {
      result += routes.duration;
    }
  }

  return result;
}

export function formatDuration(duration) {
  duration = duration / 3600;
  duration = duration.toFixed(1);
  duration = parseFloat(duration);

  if (duration === 0) {
    duration = 0.1;
  }

  return duration;
}


/**
 * 【驾车时间】 格式化2 
 * 时间=0，则显示为0分钟；
 * 0＜时间＜1分钟，则取整按照1分钟显示，如实际为20秒，则显示为1分钟；
 * 1分钟≤时间≤60分钟，按照分钟显示，并且四舍五入规则，取整。如：59.1分钟，显示为59分钟；
 * 时间≥60分钟，按照小时+分钟格式显示，并且分钟数按照四舍五入取整。如，80分钟显示为1小时20分钟。
* @param {*} second 
*/
export function formatDuration2(second) {
  if (second === 0) {
    second = 60;
  }

  let result = '';
  let minutes = Math.round(second / 60);

  if (minutes > 60) {
    let hours = Math.round(minutes / 60);
    minutes = minutes % 60;

    result = `${hours}小时${minutes}分钟`;
  } else {
    result = minutes + '分钟';
  }

  return result;
}


/**
 * 获取要绘制到地图的lines
 * 
 * @export
 * @param {any} route 接口返回完整route结果
 * @returns 
 */
export function getLines(route) { 
  let lines = [];

  for (let key in route) {
    let item = route[key];
    if (!item) continue;

    let {routes, additional_lines} = item;

    if (routes && routes.geojson) {
      lines.push({
        type: 'solidLine',
        latLngs: routes.geojson
      });
    }

    if (additional_lines) {
      additional_lines.forEach(item => {
        if (item.geojson) {
          lines.push({
            type: 'dottedLine',
            latLngs: item.geojson
          });
        }
      });
    }
  }

  return lines;
}


// WEBPACK FOOTER //
// ./src/helpers/route.js